import * as T from '^/types';

export function notificationDescDateSort(a: T.Notification, b: T.Notification): number {
  const aAt: Date = new Date(a.createdAt);
  const bAt: Date = new Date(b.createdAt);
  return bAt.valueOf() - aAt.valueOf();
}
